export default function isSituationSet(): boolean {
    const situationEl = document.getElementById(
        'situation'
    ) as HTMLSelectElement
    if (situationEl) {
        const situationValue = situationEl.value
        if (situationValue && situationValue.trim() !== '') {
            return true
        }
    }
    return false
}
